/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import {
  Button,
  FormLabel,
  ComboBox,
  FormGroup,
  Loading,
  TextArea,
  TextInput,
} from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';
import PropTypes from 'prop-types';
import { Information16 } from '@carbon/icons-react';
import { api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
  TEAM_LEADER,
} from '../../helpers/Constants';
import WorkSiteMultiSelect from './common/WorkSiteMultiSelect';
import ProjectMultiSelect from './common/ProjectMultiSelect';
import AuditorComboBox from './common/AuditorComboBox';
import CompanyComboBox from './common/CompanyComboBox';
import DivisionComboBox from './common/DivisionComboBox';
import SectionComboBox from './common/SectionComboBox';
import AuditScopeMultiSelect from './common/AuditScopeMultiSelect';
import AuditTypeComboBox from './common/AuditTypeComboBox';
import AuditTargetDropDown from './common/AuditTargetDropDown';
import { IsEditable } from '../../helpers/authorization/Policies';
import { HistoryTable } from '../../helpers/HistoryTable';
import EmailChips from '../../helpers/EmailChips';
import AuditRepository from '../../helpers/api/AuditRepository';
import ReasonForSamplingMultiSelect from './common/ReasonForSamplingMultiSelect';

export default class AuditDetails extends Component {
  constructor(props) {
    super(props);
    this.onSelectCompanyChange = this.onSelectCompanyChange.bind(this);
    this.onSelectDivisionChange = this.onSelectDivisionChange.bind(this);
    this.onSelectAuditTypeChange = this.onSelectAuditTypeChange.bind(this);
    this.onSelectSectionChange = this.onSelectSectionChange.bind(this);
    this.onSelectWorkSiteChange = this.onSelectWorkSiteChange.bind(this);
    this.onSelectScopeChange = this.onSelectScopeChange.bind(this);
    this.handleSelectedYear = this.handleSelectedYear.bind(this);
    this.handleSelectedMonth = this.handleSelectedMonth.bind(this);
    this.onSelectProjectChange = this.onSelectProjectChange.bind(this);
    this.onSelectDistributionListChange = this.onSelectDistributionListChange.bind(this);
    this.onSelectAuditorChange = this.onSelectAuditorChange.bind(this);
    this.onSelectTargetChange = this.onSelectTargetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.monthToString = this.monthToString.bind(this);
    this.monthToNumber = this.monthToNumber.bind(this);
    this.saveAudit = this.saveAudit.bind(this);
    this.updateAudit = this.updateAudit.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.onSelectReasonChange = this.onSelectReasonChange.bind(this);
    this.onOtherHSEIssuesTextChange = this.onOtherHSEIssuesTextChange.bind(this);
    this.onSelectMailCCChange = this.onSelectMailCCChange.bind(this);
    this.repository = new AuditRepository();
    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });

    this.months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    this.statuses = STATUS;
    this.state = {
      newAudit: {
        id: this.props.Audit?.id || uuid(),
        auditCode: this.props.Audit?.auditCode || null,
        company: this.props.Audit?.company || null,
        division: this.props.Audit?.division || {},
        section: this.props.Audit?.auditSection || {},
        type: this.props.Audit?.auditType || {},
        projects: this.props.Audit?.projects || [],
        worksites: this.props.Audit?.workSites || [],
        auditor:
          this.props.Audit?.auditors?.filter((x) => x.role == TEAM_LEADER).length > 0
            ? this.props.Audit?.auditors?.filter((x) => x.role == TEAM_LEADER)[0]
            : {},
        scopes: this.props.Audit?.scopes || [],
        reasonsForSampling: this.props.Audit?.reasonsForSampling || [],
        otherHSEIssues: this.props.Audit?.otherHSEIssues,
        sequence: this.props.Audit?.sequence || 0,
        month: this.monthToString(this.props.Audit?.referenceMonth),
        year: this.props.Audit?.referenceYear.toString() || null,
        target: this.props.Audit?.target || {},
        distributionList: this.props.Audit?.distributionList || null,
        mailCC: this.props.Audit?.mailCC || null,
        isHistoryModalOpen: false,
      },
      checkListCompilerChanged: false,
      isSubmitted: false,
      // editingDisabled: this.props.Audit
      //   ? this.props.Audit.idStatus === this.statuses.Consolidated
      //   : false
      editingDisabled: this.props.Audit
        ? !IsEditable(
            'Audit',
            'Planning',
            this.props.user,
            this.props.Audit.status.id,
            'All',
            this.props.Audit
          )
        : false,
      editingAuditorDisabled: this.props.Audit
        ? this.props.Audit.checkList?.idStatus > 2 ||
          !IsEditable(
            'Audit',
            'Planning',
            this.props.user,
            this.props.Audit.status.id,
            'Auditor',
            this.props.Audit
          )
        : false,
      editingDateDisabled: this.props.Audit
        ? !IsEditable(
            'Audit',
            'Planning',
            this.props.user,
            this.props.Audit.status.id,
            'Reference Date',
            this.props.Audit
          )
        : false,
    };

    const year = new Date().getFullYear();
    this.years = Array.from(new Array(5), (val, index) => (index + year).toString());
  }

  monthToString = (monthNumber) => this.months[monthNumber - 1] || '';

  monthToNumber = (monthName) => this.months.indexOf(monthName) + 1;

  showButtonHistory = () => (
    <Button kind="ghost" renderIcon={Information16} onClick={() => this.openModalHistory()}>
      History
    </Button>
    //  <Information16 onClick={() => this.openModalHistory()}></Information16>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  onSelectCompanyChange = (selectedItem) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.company = selectedItem || null;
      newAudit.projects = [];
      return { newAudit };
    });
  };

  onSelectDivisionChange = async (selectedItem) => {
    const distributionList = selectedItem
      ? await this.repository.getProgramDistributionList(selectedItem.id)
      : [];
    const toList = distributionList
      .filter((address) => {
        if (address.recipientType === 'To') return true;
        return false;
      })
      .map((address) => address.emailAddress)
      .join(',');
    const ccList = distributionList
      .filter((address) => {
        if (address.recipientType === 'Cc') return true;
        return false;
      })
      .map((address) => address.emailAddress)
      .join(',');
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.division = selectedItem || {};
      newAudit.worksites = [];
      newAudit.auditor = {};
      newAudit.distributionList = toList;
      newAudit.mailCC = ccList;
      return { newAudit };
    });
  };

  onSelectAuditTypeChange = (selectedItem) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.type = selectedItem || {};
      return { newAudit };
    });
  };

  onSelectSectionChange = (selectedItem) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.section = selectedItem || {};
      newAudit.scopes = [];
      newAudit.type = {};
      return { newAudit };
    });
  };

  onSelectWorkSiteChange = (selectedItems) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.worksites = selectedItems || [];
      return { newAudit };
    });
  };

  onSelectProjectChange = (selectedItems) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.projects = selectedItems || [];
      return { newAudit };
    });
  };

  onSelectAuditorChange = (selectedItem) => {
    const selectedAuditor = selectedItem;
    let compilerChanged = false;
    if (selectedItem) {
      compilerChanged =
        this.props.Audit &&
        this.props.Audit.checkList &&
        this.props.Audit.checkList.idCompiler !== selectedAuditor.id;
      selectedAuditor.teamLeader = true;
      selectedAuditor.role = TEAM_LEADER;
    }
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.auditor = selectedAuditor || {};
      return { newAudit };
    });
    if (compilerChanged == false) {
      this.validator.message('Reasons for change', this.state.newAudit.reasonsForChange, '');
    }
    this.setState({ checkListCompilerChanged: compilerChanged });
  };

  onSelectTargetChange = (selectedItem) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.target = selectedItem || {};
      return { newAudit };
    });
  };

  onSelectDistributionListChange = (e) => {
    const val = e;
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.distributionList = val;
      return { newAudit };
    });
  };

  onSelectMailCCChange = (e) => {
    const val = e;
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.mailCC = val;
      return { newAudit };
    });
  };

  onSelectReasonChange = (selectedItems) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.reasonsForSampling = selectedItems || [];
      newAudit.otherHSEIssues =
        newAudit.reasonsForSampling.findIndex((el) => el.name === 'Any other HSE issues') !== -1
          ? newAudit.otherHSEIssues
          : '';
      return { newAudit };
    });
  };

  onOtherHSEIssuesTextChange = (text) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.otherHSEIssues = text;
      return { newAudit };
    });
  };

  onReasonForChangeChange = (e) => {
    const val = e.target.value;
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.reasonsForChange = val;
      return { newAudit };
    });
  };

  handleSelectedMonth = (selectedItem) => {
    let month;
    try {
      month = selectedItem.selectedItem;
    } catch (error) {
      month = null;
    }
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.month = month;
      return { newAudit };
    });
  };

  handleSelectedYear = (selectedItem) => {
    let year;
    try {
      year = selectedItem.selectedItem;
    } catch (error) {
      year = null;
    }
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.year = year;
      return { newAudit };
    });
  };

  onSelectScopeChange = (selectedItems) => {
    this.setState((prevState) => {
      const newAudit = { ...prevState.newAudit };
      newAudit.scopes = selectedItems || [];
      return { newAudit };
    });
  };

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  saveAudit = async (item) => {
    try {
      this.setState({ isSubmitted: true });
      item.id = uuid();
      const { data } = await api.post('/audit', item);
      showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        `${entitiesLabels.AUDIT} ${getSuccess(data.auditCode, apioperation.POST)}`
      );
      return data;
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.AUDIT, apioperation.POST)
      );
      return null;
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  updateAudit = async (item) => {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/audit/plan', item);
      return showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        ` ${entitiesLabels.AUDIT} ${getSuccess(item.auditCode, apioperation.PUT)}`
      );
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, item.auditCode, apioperation.PUT)
      );
      return null;
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      const newAuditDTO = {
        id: this.state.newAudit.id,
        auditCode: this.props.Audit?.auditCode || null,
        referenceYear: parseInt(this.state.newAudit.year, 10),
        referenceMonth: this.monthToNumber(this.state.newAudit.month),
        idAuditType: this.state.newAudit.type.id,
        auditType: this.state.newAudit.type,
        idDivision: this.state.newAudit.division.id,
        division: this.state.newAudit.division,
        idCompany: this.state.newAudit.company?.id || null,
        company: this.state.newAudit.company || null,
        idAuditSection: this.state.newAudit.section.id,
        auditSection: this.state.newAudit.section,
        idAuditTarget: this.state.newAudit.target.id,
        target: this.state.newAudit.target,
        distributionList: this.state.newAudit.distributionList,
        mailCC: this.state.newAudit.mailCC,
        workSites: this.state.newAudit.worksites.map((elem) => elem),
        projects: this.state.newAudit.projects.map((elem) => elem),
        scopes: this.state.newAudit.scopes.map((elem) => elem),
        reasonsForSampling: this.state.newAudit.reasonsForSampling.map((elem) => elem),
        otherHSEIssues: this.state.newAudit.otherHSEIssues,
        auditors: [1].fill(this.state.newAudit.auditor),
        idCompiler: this.props.Audit?.idCompiler,
        idDataApprover: this.props.Audit?.idDataApprover,
        idDivisionManager: this.props.Audit?.idDivisionManager,
        idStatus: this.props.Audit?.idStatus,
        status: this.props.Audit?.status || null,
        compiler: this.props.Audit?.compiler || null,
        createdBy: this.props.Audit?.createdBy || null,
        createdOn: this.props.Audit?.createdOn || null,
        updatedBy: this.props.Audit?.updatedBy || null,
        updatedOn: this.props.Audit?.updatedOn || null,
      };
      if (this.props.Audit) {
        const auditors = this.props.Audit?.auditors;
        auditors.shift();
        auditors.unshift(this.state.newAudit.auditor);
        const uniqAuditors = auditors.reduce((a, b) => {
          if (!a.find((c) => c.id === b.id)) a.push(b);
          return a;
        }, []);
        newAuditDTO.auditors = uniqAuditors;
        newAuditDTO.updatedBy = this.props.user.email;
        newAuditDTO.updatedOn = new Date();
        newAuditDTO.idCheckList = this.props.Audit.idCheckList;
        newAuditDTO.checkList = this.props.Audit.checkList || null;
        newAuditDTO.sequence = this.props.Audit.sequence;
        newAuditDTO.reportSummary = this.props.Audit.reportSummary;
        newAuditDTO.additionalNotes = this.props.Audit.additionalNotes;
        newAuditDTO.startDate = this.props.Audit.startDate;
        newAuditDTO.endDate = this.props.Audit.endDate;
        newAuditDTO.reasonsForChange = this.state.newAudit.reasonsForChange;
        newAuditDTO.newCarManagement = this.props.Audit.newCarManagement;
        await this.updateAudit(newAuditDTO);
        this.props.onUpdate(newAuditDTO);
      } else {
        newAuditDTO.createdBy = this.props.user.email;
        newAuditDTO.createdOn = new Date();
        newAuditDTO.updatedBy = this.props.user.email;
        newAuditDTO.updatedOn = newAuditDTO.createdOn;
        newAuditDTO.idStatus = 1;
        newAuditDTO.status = {
          id: 1,
          name: 'Draft',
          planningName: 'Draft',
          reportingName: 'Opened',
          carManagementName: 'Assigned',
        };
        const newItem = await this.saveAudit(newAuditDTO);
        if (newItem) this.props.onSave(newItem);
      }
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.AUDIT} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  render() {
    const validations = {
      division: this.validator.message('division', this.state.newAudit.division.id, 'required'),
      section: this.validator.message('Section', this.state.newAudit.section.id, 'required'),
      type: this.validator.message('Audit Type', this.state.newAudit.type.id, 'required'),
      scope: this.validator.message('Scope', this.state.newAudit.scopes[0], 'required'),
      month: this.validator.message('month', this.state.newAudit.month, 'required'),
      year: this.validator.message('year', this.state.newAudit.year, 'required'),
      auditor: this.validator.message('auditor', this.state.newAudit.auditor.id, 'required'),
      target: this.validator.message('target', this.state.newAudit.target.id, 'required'),
      distributionList: this.validator.message(
        'distributionList',
        this.state.newAudit.distributionList,
        'required'
      ),
      // reasonsForSampling: this.validator.message(
      //   'Reasons For Sampling',
      //   this.state.newAudit.reasonsForSampling[0],
      //   'required'
      // ),
    };

    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            {this.props.Audit ? (
              <h3 className="bx--modal-header__heading">
                {`Edit Audit Program: ${this.props.Audit.auditCode || ''} `}
              </h3>
            ) : (
              <h3 className="bx--modal-header__heading">Program New Audit</h3>
            )}
            {this.props.Audit ? this.showButtonHistory() : ''}
            {
              <HistoryTable
                entityId={this.state.newAudit.id}
                isOpenModal={this.state.isHistoryModalOpen}
                onClose={() => this.closeModalHistory()}
              />
            }
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.props.onCancel}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel>Section *</FormLabel>
                  <SectionComboBox
                    invalid={validations.section != null}
                    invalidText={validations.section}
                    onChange={this.onSelectSectionChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.SECTION, apioperation.GET)
                      );
                    }}
                    selectedItem={this.state.newAudit.section}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel>Reference Date *</FormLabel>
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-4">
                      <ComboBox
                        id="cmbReferenceYear"
                        invalid={validations.year != null}
                        invalidText={validations.year}
                        placeholder="year"
                        items={this.years}
                        selectedItem={this.state.newAudit.year || null}
                        onChange={this.handleSelectedYear}
                        itemToString={(item) => item || ''}
                        disabled={this.state.editingDateDisabled}
                      />
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-4">
                      <ComboBox
                        id="cmbReferenceMonth"
                        invalid={validations.month != null}
                        invalidText={validations.month}
                        placeholder="month"
                        items={this.months}
                        selectedItem={this.state.newAudit.month || null}
                        onChange={this.handleSelectedMonth}
                        itemToString={(item) => item || ''}
                        disabled={this.state.editingDateDisabled}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Scopes *</FormLabel>
                  <AuditScopeMultiSelect
                    invalid={validations.scope != null}
                    invalidText={validations.scope}
                    onChange={this.onSelectScopeChange}
                    section={this.state.newAudit.section.id}
                    key={this.state.newAudit.section.id}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.SCOPE, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newAudit.scopes}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel>Type of audit *</FormLabel>
                  <AuditTypeComboBox
                    invalid={validations.type != null}
                    invalidText={validations.type}
                    onChange={this.onSelectAuditTypeChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.TYPEAUDIT, apioperation.GET)
                      );
                    }}
                    section={this.state.newAudit.section.id}
                    key={this.state.newAudit.section.id}
                    initialSelectedItem={this.state.newAudit.type}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Main Division *</FormLabel>
                  <DivisionComboBox
                    invalid={validations.division != null}
                    invalidText={validations.division}
                    onChange={this.onSelectDivisionChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.MAINDIVISION, apioperation.GET)
                      );
                    }}
                    selectedItem={this.state.newAudit.division}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Company</FormLabel>
                  <CompanyComboBox
                    onChange={this.onSelectCompanyChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.COMPANY, apioperation.GET)
                      );
                    }}
                    selectedItem={this.state.newAudit.company}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class worksite">Work Sites</FormLabel>
                  <WorkSiteMultiSelect
                    onChange={this.onSelectWorkSiteChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.WORKSITE, apioperation.GET)
                      );
                    }}
                    division={this.state.newAudit.division.id}
                    key={this.state.newAudit.division.id}
                    initialSelectedItems={this.state.newAudit.worksites}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class worksite">Projects</FormLabel>
                  <ProjectMultiSelect
                    onChange={this.onSelectProjectChange}
                    company={this.state.newAudit.company?.id}
                    key={this.state.newAudit.company?.id}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.PROJECT, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newAudit.projects}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div
                className={
                  this.state.checkListCompilerChanged == true
                    ? 'bx--col-lg-6 bx--col-md-12'
                    : 'bx--col-lg-12 bx--col-md-12'
                }
              >
                <FormGroup>
                  <FormLabel className="some-class">{TEAM_LEADER} *</FormLabel>
                  <AuditorComboBox
                    division={this.state.newAudit.division?.id}
                    invalid={validations.auditor != null}
                    key={this.state.newAudit.division?.id}
                    invalidText={validations.auditor}
                    onChange={this.onSelectAuditorChange}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.AUDITOR, apioperation.GET)
                      );
                    }}
                    //userDivision={this.props.userDivision || []} //B1_Audit_Module_Optimization
                    selectedItem={this.state.newAudit.auditor}
                    disabled={this.state.editingAuditorDisabled}
                  />
                </FormGroup>
              </div>
              {this.state.checkListCompilerChanged == true ? (
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormGroup>
                    <FormLabel className="some-class">Reason for change *</FormLabel>

                    <TextInput
                      id="inputReasonForChange"
                      invalid={
                        this.validator.message(
                          'Reasons for change',
                          this.state.newAudit.reasonsForChange,
                          'required'
                        ) != null
                      }
                      invalidText={this.validator.message(
                        'Reasons for change',
                        this.state.newAudit.reasonsForChange,
                        'required'
                      )}
                      labelText=""
                      onChange={this.onReasonForChangeChange}
                      onClick={() => {}}
                      type="text"
                    />
                  </FormGroup>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Target *</FormLabel>
                  <AuditTargetDropDown
                    invalid={validations.target != null}
                    invalidText={validations.target}
                    onChange={this.onSelectTargetChange}
                    openUp
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.TARGET, apioperation.GET)
                      );
                    }}
                    initialSelectedItem={this.state.newAudit.target}
                    disabled={this.state.editingDisabled}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Reasons For Sampling *</FormLabel>
                  {this.state.editingDisabled == true ? (
                    <ReasonForSamplingMultiSelect
                      onChange={this.onSelectReasonChange}
                      onError={(error) => {
                        showNotification.error(
                          `${entitiesLabels.ERROR}`,
                          getError(error, entitiesLabels.REASONFORSAMPLING, apioperation.GET)
                        );
                      }}
                      openUp
                      initialSelectedItems={this.state.newAudit.reasonsForSampling}
                      disabled={this.state.editingDisabled}
                    />
                  ) : (
                    <ReasonForSamplingMultiSelect
                      onChange={this.onSelectReasonChange}
                      invalid={
                        this.state.editingDisabled
                          ? false
                          : this.validator.message(
                              'Reasons For Sampling',
                              this.state.newAudit.reasonsForSampling[0],
                              'required'
                            ) != null
                      }
                      invalidText={
                        this.state.editingDisabled
                          ? ''
                          : this.validator.message(
                              'Reasons For Sampling',
                              this.state.newAudit.reasonsForSampling[0],
                              'required'
                            )
                      }
                      onError={(error) => {
                        showNotification.error(
                          `${entitiesLabels.ERROR}`,
                          getError(error, entitiesLabels.REASONFORSAMPLING, apioperation.GET)
                        );
                      }}
                      openUp
                      initialSelectedItems={this.state.newAudit.reasonsForSampling}
                      disabled={this.state.editingDisabled}
                    />
                  )}
                </FormGroup>
              </div>
            </div>

            {this.state.newAudit.reasonsForSampling.findIndex(
              (el) => el.name === 'Any other HSE issues'
            ) !== -1 ? (
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Any Other HSE Issues">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputOtherHSEIssue"
                      name="inputOtherHSEIssue"
                      cols={100}
                      disabled={false}
                      invalid={false}
                      light={false}
                      placeholder=""
                      rows={4}
                      value={this.state.newAudit.otherHSEIssues || ''}
                      onChange={(el) => this.onOtherHSEIssuesTextChange(el.target.value)}
                    />
                    {validations.question}
                  </FormGroup>
                </div>
              </div>
            ) : (
              ''
            )}

            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Mail To*</FormLabel>
                  <EmailChips
                    id="inputDistributionList"
                    invalid={validations.distributionList != null}
                    // invalidText={validations.distributionList}
                    value={this.state.newAudit.distributionList || ''}
                    disabled={this.state.editingDisabled}
                    type="text"
                    onChange={this.onSelectDistributionListChange}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="some-class">Mail CC</FormLabel>
                  <EmailChips
                    id="inputMailCC"
                    // invalid={validations.distributionList != null}
                    // invalidText={validations.distributionList}
                    value={this.state.newAudit.mailCC || ''}
                    disabled={this.state.editingDisabled}
                    type="text"
                    onChange={this.onSelectMailCCChange}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button className="button--max-width" kind="secondary" onClick={this.props.onCancel}>
              Cancel
            </Button>

            <Button
              className="button--max-width"
              kind="primary"
              disabled={
                this.state.editingDisabled &&
                this.state.editingAuditorDisabled &&
                this.state.editingDateDisabled
              }
              onClick={this.handleSubmit}
            >
              Save
            </Button>
          </div>
          {this.renderLoadingModal()}
        </div>
      </div>
    );
  }
}
AuditDetails.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  Audit: PropTypes.object,
  user: PropTypes.object.isRequired,
};
AuditDetails.defaultProps = { Audit: null };
